import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"border-bottom":"1px solid #d1d1d1"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "mr-2",
  style: {"font-size":"14px"}
}, "지급일 | ", -1)

import { useStore } from 'vuex';
import axios from 'axios';
import { onMounted, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'WageLedgerPayDate',
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const store = useStore();
const payDate = ref<string | null>(null);
const code = ref<string>(store.state.AdminSisulCode);

const emit = __emit
const getPayDate = async () => {
  try {
    const response = await axios.get(`/api/getPayDate/${code.value}/${store.state.AdminYYMM}`);
    const responseData = response.data;
    if (responseData) {
      payDate.value = responseData;
      return responseData;
    } else {
      console.error('에러가 발생했습니다.');
    }
  } catch (error) {
    console.error('errorMsg:', error);
  }
};

const setPayDate = async () => {
  try {
    const response = await axios.post(`/api/setPayDate/${payDate.value}/${code.value}/${store.state.AdminYYMM}`);
    const result = response.data;
    if (result.success === true) {
      alert('지급일이 저장되었습니다.');
      emit('success');
    } else {
      alert('실패하였습니다. 관리자에게 문의해주세요.');
    }
  } catch (error) {
    alert('처리할 수 없습니다.');
    console.error(error);
  }
};
onMounted(async() => {
 await getPayDate();
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(store).state.role > 3)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "date",
          color: "indigo",
          style: {"font-size":"14px"},
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payDate).value = $event)),
          min: "2000-01-01",
          max: "2099-12-31"
        }, null, 512)), [
          [_vModelText, payDate.value]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          readonly: "",
          type: "date",
          color: "indigo",
          style: {"font-size":"14px"},
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payDate).value = $event)),
          min: "2000-01-01",
          max: "2099-12-31"
        }, null, 512)), [
          [_vModelText, payDate.value]
        ]),
    (_unref(store).state.role > 3)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 2,
          onClick: setPayDate,
          class: "btnColorPurple ml-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode("저장")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})